import { withClientErrorPage } from '@sm/webassets';
import FourHundredError from './FourHundredError';

export default withClientErrorPage(FourHundredError, { titularElementTag: 'h1', errorCode: 400 });
